module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Remove appointment?"},"es":{"dialogTitle":"Eliminar cita?"}}')
  delete Component.options._Ctor
}
